import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import { useRecentDispatches } from '@/hooks/useDashboardStats';
import type { DispatchStatus } from '@/types/api.types';

const STATUS_LABEL: Record<DispatchStatus, string> = {
  pending: 'Pendente',
  sent: 'Enviado',
  delivered: 'Entregue',
  read: 'Lido',
  failed: 'Falhou',
};

const STATUS_VARIANT: Record<DispatchStatus, 'default' | 'secondary' | 'destructive' | 'outline'> = {
  pending: 'outline',
  sent: 'secondary',
  delivered: 'default',
  read: 'default',
  failed: 'destructive',
};

export function RecentDispatchesTable() {
  const { data: dispatches = [], isLoading } = useRecentDispatches();

  if (isLoading) {
    return (
      <div className="flex justify-center py-8">
        <LoadingSpinner size="sm" />
      </div>
    );
  }

  if (dispatches.length === 0) {
    return (
      <p className="py-8 text-center text-sm text-muted-foreground">Nenhum disparo ainda</p>
    );
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Destinatário</TableHead>
          <TableHead>Status</TableHead>
          <TableHead>Criado</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {dispatches.map((d) => (
          <TableRow key={d.id}>
            <TableCell>
              <p className="font-mono text-xs">{d.contactPhone}</p>
              {d.contactName && (
                <p className="text-xs text-muted-foreground">{d.contactName}</p>
              )}
            </TableCell>
            <TableCell>
              <Badge variant={STATUS_VARIANT[d.status]}>{STATUS_LABEL[d.status]}</Badge>
            </TableCell>
            <TableCell className="text-xs text-muted-foreground">
              {format(new Date(d.createdAt), "dd/MM 'às' HH:mm", { locale: ptBR })}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
